import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MenuItem, ConfirmEventType, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { style } from '@angular/animations';
import { CommonService } from 'src/app/services/common.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { formatDate } from '@angular/common';
import { DateValidator, WithdrawDateValidator, WithdrawDateValidator2, WithdrawDateValidator3 } from '../../../../_helpers/must-match.validator';
import { maxYearFunction } from '../../../../_helpers/utility';
import { CategoryService } from 'src/app/services/category.service';
import * as moment from "moment";
@Component({
  selector: 'app-create-tournaments',
  templateUrl: './create-tournaments.component.html',
  styleUrls: ['./create-tournaments.component.scss'],
  providers: [ConfirmationService, MessageService]

})

export class CreateTournamentsComponent implements OnInit {
  @ViewChild('fileUpload', { static: false }) fileUpload: any;
  logoimagearray: any;
  showpage: boolean = false;
  tournamentstatus: boolean = false;
  public showPicError: boolean = false;
  step: number = 0;
  activeIndex: number = 0;
  public courtTypeList = environment.courtTypeList;
  public cotegorylist = environment.categorylist;
  public agegrouplist = environment.agegrouplist;
  public selectedcourtType;
  public selectedmatchType;
  public selectedageGroup;
  uploadedFiles: any[] = [];
  public uploadedpic;
  submitted = false;
  catsubmitted = false;
  items: MenuItem[];
  logoImage: any;
  public showinglogoForm: boolean = false;
  public showingSignitureForm: boolean = false;
  tournamentform: FormGroup;
  categoryform: FormGroup;
  tournamentLogoform: FormGroup;
  citylist: any = [];
  statelist: any = [];
  countryCode = "IN";
  countryName = 'India'
  statecode: any;
  statename: any;
  citycode: any;
  cityname: any;
  errorMessage = '';
  matchCategoryArray: any = [];
  loggedInAcademy;
  loggedInAcademyId;
  tournamentId: any;
  sponsorimagelist: any;
  id: any;
  pagetitle = 'CREATE TOURNAMENT';
  buttontitle = 'Save & Create';
  item: any;
  logos: any;
  categorydata: any;
  removedCategoryData = [];
  image: any;
  imageid: any;
  public catList: any[] = [];
  public tplpointlist = [];
  public subAgegroup = [];
  public maxPlayerList = [{ value: 8, label: 8 }, { value: 16, label: 16 }, { value: 32, label: 32 }, { value: 64, label: 64 }, { value: 128, label: 128 }];
  public minDateValue = new Date();
  minYear = environment.minYear;
  yearRange;
  logoimage: any;
  public junior_age_group = ['junior_boys_singles', 'junior_boys_doubles', 'junior_girls_singles', 'junior_girls_doubles'];
  public senior_age_group = ['mens_singles', 'mens_doubles', 'womens_singles', 'womens_doubles', 'mixed_doubles', 'asst_coaches_doubles', 'asst_coaches_singles'];
  public coach_group = ['asst_coaches_doubles', 'asst_coaches_singles'];
  addTournamentCategory = [];
  updateTournamentCategory = [];
  isTournamentCreate: boolean = true;
  oldstep: number = 0;
  public showImageError: boolean = false;
  public showUploadedpic = false;
  uploadedSignitureFiles = [];
  signitureImage: any;
  public tournamentDirectorsign;
  public showtournamentDirectorsign:boolean = false;
  public showAddSponsor:boolean =true;
  countrylist: any[] = [];
  drawTypes: any;
  constructor(private categoryService: CategoryService, private fb: FormBuilder, private commonService: CommonService, private confirmationService: ConfirmationService, private tournamentservice: TournamentsService, private messageService: MessageService,
    private tokenStorage: TokenStorageService, private router: Router, private renderer: Renderer2, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.tournamentId = this.route.snapshot.paramMap.get('id');
    this.oldstep = Number(this.route.snapshot.paramMap.get('step'));
    if (this.oldstep != undefined) {
      this.step = this.oldstep;
      this.activeIndex = this.oldstep;
    }
    this.yearRange = this.minYear + ":2030";
    this.loggedInAcademy = this.tokenStorage.getUser();

    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    this.tournamentform = this.fb.group({
      // name: ['', { validators: [Validators.required, Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$")], updateOn: 'blur' }],
      name: ['', { validators: [Validators.required,Validators.pattern(/^[\p{L}\p{N}\p{Extended_Pictographic}\p{Emoji_Component}\uFE0F\s'@#$%&^*_\-]+$/u)], updateOn: 'blur' }],
      organizercontactnumber: [, { validators: [Validators.required, Validators.pattern("[0-9 ]{10}")], updateOn: 'blur' }],
      whatsAppgrouplink: ['', { validators: [Validators.required, Validators.pattern("(https?:\/\/)?chat\.whatsapp\.com\/(?:invite\/)?([a-zA-Z0-9_-]{22})$")], updateOn: 'blur' }],
      lastdateofregistration: ['', { validators: [Validators.required] }],
      startdate: ['', { validators: [Validators.required] }],
      enddate: ['', { validators: [Validators.required] }],
      lastdateofwithdraw: ['', { validators: [Validators.required] }],
      // drawDate: ['', { validators: [Validators.required] }],
      regulations: [''],
      clubname: ['', { validators: [Validators.required], updateOn: 'blur' }],
      state: ['', { validators: [Validators.required], updateOn: 'blur' }],
      city: ['', { validators: [Validators.required], updateOn: 'blur' }],
      address: ['', { validators: [Validators.required], updateOn: 'blur' }],
      courttype: ['', { validators: [Validators.required], updateOn: 'blur' }],
      zipcode: ['', { validators: [Validators.required], updateOn: 'blur' }],
      authority_designation: ['Tournament Director'],
      authority_person_name: ['', { validators: [Validators.required, Validators.maxLength(20)] }],
      drawType: ['', [Validators.required]],
      showplayerList: [true],
      phoneCode: [null,[Validators.required]]
    }, {
      validator: [
        DateValidator('startdate', 'enddate'),
        DateValidator('lastdateofregistration', 'startdate'),
        //DateValidator('lastdateofwithdraw', 'startdate'),
        WithdrawDateValidator2('lastdateofwithdraw', 'lastdateofregistration', 'startdate'),
        // WithdrawDateValidator3('drawDate', 'lastdateofwithdraw', 'startdate'),
      ]
    });

    this.tournamentLogoform = this.fb.group({
      // name: ['', [Validators.required, Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$")]],
      name: ['', { validators: [Validators.required,Validators.pattern(/^[\p{L}\p{N}\p{Extended_Pictographic}\p{Emoji_Component}\uFE0F\s'@#$%&^*_\-]+$/u)], updateOn: 'blur' }],

    });
    this.categoryform = this.fb.group({
      matchCategoryArray: this.fb.array([this.newcategorysection()])
    }),

      this.getTournamentCategory();
    var loggedInUser = this.tokenStorage.getUser();
    this.tplpointlist = loggedInUser.userdata['points'];
    this.items = [
      {
        label: 'CREATE',
      },
      {
        label: 'SPONSOR LOGOS',
      },
      {
        label: 'CATEGORY',
      },
    ];
    
    this.getDrawTypes();
    this.getCountries();
    this.getState(this.countryCode);
    // this.getTournamentId();
    if (this.tournamentId != undefined) {
      // this.buttontitle = 'Create / Update Draws',
      this.pagetitle = 'UPDATE TOURNAMENT'
      this.gettournamentDetails(this.tournamentId);
      this.getlogo(this.tournamentId)
    }
    this.renderer.addClass(document.body, 'createTournamentbody');
  }
  
  getDrawTypes() {
    const query = `?filterByParentCategory=Draw Type`;
    this.categoryService.getCategoryList(query).subscribe((data:any)=>{
      this.drawTypes = data?.data?.items;
      this.tournamentform.controls.drawType.setValue(this.drawTypes.find(ele => ele.name === 'Knockout'));
    })
  }
  
  onChangeCountryCode(event) {
    this.countryCode = event.value.code;
    this.countryName = event.value.name;
    this.getState(event.value.code);
    this.tournamentform.get('state').reset();
    this.tournamentform.get('city').reset();
    this.citylist = null;
  }
  
  getCountries() {
    this.commonService.getCountryList().subscribe((data) => {
      this.countrylist = data.data.items;
      this.tournamentform.controls.phoneCode.setValue(this.countrylist.find(ele => ele.phone_code === '91'));
    })
  }

  getState(countryCode) {
    this.commonService.getStateList(countryCode).subscribe((res) => {
      this.statelist = res.data.items;
    })
  }
  
  onclickstate(event) {
    this.statecode = event.value.code;
    this.statename = event.value.name;
    this.getCity(this.statecode);
  }

  getCity(statecode) {
    this.commonService.getCityList(statecode).subscribe(
      data => {
        this.citylist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onCitySelect(event) {
    this.citycode = event.value.code;
    this.cityname = event.value.name;
  }

  get f() {
    return this.tournamentform.controls;
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'createTournamentbody');
  }
  getTournamentCategory() {
    var parentlist = this.tokenStorage.getCategorylist();
    let obj = parentlist.find(o => o.slug === "tournament_category");
    if (obj.id) {
      var query = "?filterByDisable=false&filterByStatus=true&filterByParent=" + obj.id + "&sortBy=created_at&orderBy=1";
      this.categoryService.getCategoryList(query).subscribe(
        data => {
          var catlist = data.data.items;
          catlist.forEach(element => {
            this.catList.push({ label: element.name, value: element.id, slug: element.slug });
          })
        },
        err => {
          this.errorMessage = err.error.message;
        }
      );
    }

  }
  get categorysection() {
    return this.categoryform.controls['matchCategoryArray']['controls'];
  }
  categorysectionform(): FormArray {
    return this.categoryform.get("matchCategoryArray") as FormArray;
  }
  newcategorysection(): FormGroup {
    return this.fb.group({
      categoryId: [],
      matchtype: ['', [Validators.required]],
      agegroup: ['', [Validators.required]],
      pointstructure: ['', [Validators.required]],
      entryFee: [100, [Validators.required, Validators.min(100)]],
      maxplayer: [8, [Validators.required, Validators.min(8), Validators.max(128)]],
      disable: false,
      status: true
    })
  }

  getlogo(tournamentId) {
    var query = "?filterByStatus=true&filterByDisable=false&filterByTournamentId=" + tournamentId
    this.tournamentservice.getlogo(query).subscribe(res => {
      this.sponsorimagelist = res.data.items;
      if(this.sponsorimagelist.length >= 5){
        this.showAddSponsor = false;
      } else {
        this.showAddSponsor = true;
      }
    })
  }

  gettournamentDetails(id) {
    this.tournamentservice.getTournamentDetailsByID(id).subscribe(res => {
      this.item = res;
      this.tournamentform.controls.name.setValue(this.item.name);
      this.tournamentform.controls.organizercontactnumber.setValue(this.item.organizercontactnumber);
      this.tournamentform.controls.whatsAppgrouplink.setValue(this.item.whatsAppgrouplink);
      this.tournamentform.controls.authority_person_name.setValue(this.item.authority_person_name);
      //this.tournamentform.controls.lastdateofregistration.setValue(moment(this.item.lastdateofregistration).format('DD-MM-YYYY'));
      //this.tournamentform.controls.startdate.setValue(moment(this.item.startdate).format('DD-MM-YYYY'));
      if (this.item['lastdateofregistration']) {
        this.tournamentform.get('lastdateofregistration').setValue(moment(this.item['lastdateofregistration']).toDate());
        this.tournamentform.get('lastdateofregistration').setErrors(null);
      }
      // if (this.item['drawDate']) {
      //   this.tournamentform.get('drawDate').setValue(moment(this.item['drawDate']).toDate());
      //   this.tournamentform.get('drawDate').setErrors(null);
      // }
      if (this.item['startdate']) {
        this.tournamentform.get('startdate').setValue(moment(this.item['startdate']).format('DD-MM-YYYY'));
        this.tournamentform.get('startdate').setErrors(null);
      }
      if (this.item['enddate']) {
        this.tournamentform.get('enddate').setValue(moment(this.item['enddate']).format('DD-MM-YYYY'));
        this.tournamentform.get('enddate').setErrors(null);
      }
      if (this.item['lastdateofwithdraw']) {
        //this.tournamentform.controls.lastdateofwithdraw.setValue(moment(this.item.lastdateofwithdraw).format('DD-MM-YYYY'));
        this.tournamentform.get('lastdateofwithdraw').setValue(moment(this.item['lastdateofwithdraw']).toDate());
        this.tournamentform.get('lastdateofwithdraw').setErrors(null);
      }
      this.tournamentform.controls.regulations.setValue(this.item.regulations);
      this.tournamentform.controls.clubname.setValue(this.item.clubname);
      this.tournamentform.controls.phoneCode.setValue(this.countrylist.find(ele => ele.phone_code === this.item['phoneCode']));
      this.tournamentform.controls.state.setValue({ 'name': this.item.statename, 'code': this.item.statecode });
      if (this.item['citycode']) {
        this.getCity(this.item['statecode'])
        this.tournamentform.controls.city.setValue({ 'name': this.item.cityname, 'code': this.item.citycode });
      }
      this.tournamentform.controls.address.setValue(this.item.address);
      this.tournamentform.controls.zipcode.setValue(this.item.zipcode);
      this.tournamentform.controls.drawType.setValue(this.drawTypes.find(ele => ele.id === this.item['drawType']));
      this.tournamentform.controls.showplayerList.setValue(this.item.showplayerList);
      if (this.item['courttype']) {
        this.courtTypeList.forEach(element => {
          if (element.value == this.item['courttype']) {
            this.tournamentform.controls.courttype.setValue({ label: element.label, value: element.value })
          }
        })
      }
      if (this.item['authority_signiture'] != undefined && this.item['authority_signiture'] != '') {
        this.tournamentDirectorsign = this.item['authority_signiture'];        
        this.showtournamentDirectorsign=true;
      } else {
        this.showtournamentDirectorsign=false;
      }
      this.logos = this.item['sponsor_logo'];
      this.categorydata = this.item['tournamentCategories']
      if (this.categorydata != null) {
        for (let i = 0; i < this.categorydata.length; i++) {
          this.addCategorform();
        }
      }
      if (this.categorydata != undefined) {
        setTimeout(() => {
          for (var i = 0; i < this.categorydata.length; i++) {
            this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['categoryId']: this.categorydata[i]._id });
            //this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['maxplayer']: this.categorydata[i].maxPlayer });
            this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['entryFee']: this.categorydata[i].entryFee });
            this.tplpointlist.forEach(pointElement => {
              if (pointElement.value == this.categorydata[i]['pointStructureData'][0]['_id']) {
                this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['pointstructure']: { value: pointElement.value, label: pointElement.label, slug: pointElement.slug, status: pointElement.status } });
              }
            })
            this.maxPlayerList.forEach(maxplayerElement => {
              if (maxplayerElement.value == this.categorydata[i].maxPlayer) {
                this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['maxplayer']: { value: maxplayerElement.value, label: maxplayerElement.label } });
              }
            })
            this.catList.forEach(aelement => {
              if (this.categorydata[i].matchtypeData[0]['_id'] == aelement.value) {
                this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['matchtype']: { label: aelement.label, value: aelement.value, slug: aelement.slug } });
                this.onMatchSelect({ 'slug': aelement.slug }, i, false);
                //console.log(this.subAgegroup[i]);
              }
            })
            // this.catList.forEach(aelement => {
            //   if (this.categorydata[i].matchtypeData[0]['_id'] == aelement.value) {
            //     this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['matchtype']: { label: aelement.label, value: aelement.value, slug: aelement.slug } });
            //   }
            // })
          }
        }, 200);
        if (this.categoryform.controls.matchCategoryArray['controls'].length >= 1) {
          let length = this.categoryform.controls.matchCategoryArray['controls'].length;
          this.categoryform.controls.matchCategoryArray['controls'].splice(Number(length) - Number(1), 1);
        }
      }
      // if (this.item) {
      this.isTournamentCreate = false;
      // }

    })
  }
  getTournamentId() {
    var query = "?filterByCategoryId=" + this.loggedInAcademyId
    this.tournamentservice.getTournament(query).subscribe(res => {
      if (res.data.items[0] != undefined) {
        this.tournamentId = res.data.items[0].id;
      }
      //console.log("tournamentlist get id for category form", this.tournamentId);
    })
  }

  addCategorform() {
    this.categorysectionform().push(this.newcategorysection());
  }

  removeCategory(j: number) {
    var categorydata = this.categoryform.value;
    categorydata['matchCategoryArray'][j]['disable'] = true;
    categorydata['matchCategoryArray'][j]['status'] = false;
    let obj = categorydata['matchCategoryArray'][j];

    this.removedCategoryData.push(obj);

    if (this.categorydata != undefined && this.categorydata.length < j) {
      let dummyData = []
      dummyData = this.categorydata;
      this.categorydata = dummyData.filter(item => item._id !== categorydata['matchCategoryArray'][j]['categoryId']);
      let tplPoints = [];
      for (var i = 0; i < this.categorydata.length; i++) {
        if (this.categorydata[i]._id != categorydata['matchCategoryArray'][j]['categoryId']) {
          this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['categoryId']: this.categorydata[i]._id });
          //this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['maxplayer']: this.categorydata[i].maxPlayer });
          this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['entryFee']: this.categorydata[i].entryFee });
          this.tplpointlist.forEach(pointElement => {
            if (pointElement.value == this.categorydata[i]['pointStructureData'][0]['_id']) {
              this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['pointstructure']: { value: pointElement.value, label: pointElement.label, slug: pointElement.slug, status: pointElement.status } });
            }
          })
          // this.maxPlayerList.forEach(maxplayerElement => {
          //   if (maxplayerElement.value == this.categorydata[i].maxPlayer ) {
          //     this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['maxplayer']: { value: maxplayerElement.value, label: maxplayerElement.label} });
          //   }
          // })
          this.catList.forEach(aelement => {
            if (this.categorydata[i].matchtypeData[0]['_id'] == aelement.value) {
              this.categoryform.controls.matchCategoryArray['controls'][i].patchValue({ ['matchtype']: { label: aelement.label, value: aelement.value, slug: aelement.slug } });
              this.onMatchSelect({ 'slug': aelement.slug }, i, false);
              //console.log(this.subAgegroup[i]);
            }
          })
        }
      }
      if (this.categoryform.controls.matchCategoryArray['controls'].length >= 1) {
        let length = this.categoryform.controls.matchCategoryArray['controls'].length;
        this.categoryform.controls.matchCategoryArray['controls'].splice(Number(length) - Number(1), 1);
      }
    } else {
      this.categorysectionform().removeAt(j);
    }
  }

  onCourtSelect(event) {
    this.selectedcourtType = event.value.value;
  }

  onMatchSelect(event, i, fromForm) {
    var parentlist = this.tokenStorage.getCategorylist();
    let objJunior;
    let objSenior;
    let selectedCat;
    if (fromForm) {
      this.selectedmatchType = event.value.value;
      objJunior = this.junior_age_group.find(o => o === event.value.slug);
      objSenior = this.senior_age_group.find(o => o === event.value.slug);
      selectedCat = event.value.slug;
    } else {
      this.selectedmatchType = event.value;
      objJunior = this.junior_age_group.find(o => o === event.slug);
      objSenior = this.senior_age_group.find(o => o === event.slug);
      selectedCat = event.slug;
    }
    let childSlug;
    let childSlugObj;
    if (objJunior != undefined) {
      childSlug = "tournament_junior_agegroup";
      childSlugObj = parentlist.find(o => o.slug === "tournament_junior_agegroup");
    } else if (objSenior != undefined) {
      childSlug = "tournament_senior_agegroup";
      childSlugObj = parentlist.find(o => o.slug === "tournament_senior_agegroup");
    }
    var query;
    // if (selectedCat == "asst_coaches_singles" || selectedCat == "asst_coaches_doubles") {
    //   query = "?filterByDisable=false&filterByStatus=true&filterByParent=" + childSlugObj.id + "&filterBySlug=Open&sortBy=created_at&orderBy=1";
    // } else {
    //   query = "?filterByDisable=false&filterByStatus=true&filterByParent=" + childSlugObj.id + "&sortBy=created_at&orderBy=1";
    // }
    //commented above code to show call cagegroups to asst_coaches_single and doubles
    query = "?filterByDisable=false&filterByStatus=true&filterByParent=" + childSlugObj.id + "&sortBy=created_at&orderBy=1";

    this.categoryService.getCategoryList(query).subscribe(
      data => {
        var catlist = data.data.items;
        var tmpcatList = [];
        catlist.forEach(element => {
          let obj = { label: element.name, value: element.id, slug: element.slug };
          tmpcatList.push(obj);
        })
        this.subAgegroup[i] = tmpcatList;
        if (this.categorydata != undefined) {
          for (var j = 0; j < this.categorydata.length; j++) {
            this.subAgegroup[i].forEach(aelement => {
              if (this.categorydata[j].ageGroupData[0]['_id'] == aelement.value) {
                this.categoryform.controls.matchCategoryArray['controls'][j].patchValue({ ['agegroup']: { label: aelement.label, value: aelement.value, slug: aelement.slug } });
              }
            })
          }
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onAgeGroupSelect(event) {
    this.selectedageGroup = event.value.value;
  }

  picUploader(event) {
    this.logoImage = [];
    let index = 0;
    this.showImageError = false;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.logoImage.push({ 'file': reader.result, 'alt': '', 'default': '' });
          index++;
        }
      }
    }
  }

  clear() { this.fileUpload.clear(); }

  logosave() {
    var sponsorlogo = this.tournamentLogoform.value;
    if (this.logoImage == undefined) {
      this.showImageError = true;
      return;
    } else {
      this.showImageError = false;
    }
    sponsorlogo['sponsor_logos'] = this.logoImage;
    sponsorlogo['tournamentId'] = this.tournamentId;
    sponsorlogo = JSON.stringify(sponsorlogo, null, 4);
    this.addlogo(sponsorlogo);
  }
  addlogo(sponsorlogo) {
    this.tournamentservice.addlogo(sponsorlogo).subscribe(
      data => {
        this.showinglogoForm = false;
        this.tournamentLogoform.reset();
        this.uploadedFiles = [];;
        this.logoImage = [];
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Sponsor Logo Added Successfully', life: 6000 });
        setTimeout(() => {
          // this.router.navigate(['/']);
        }, 2000);
        this.clear();
        //this.router.navigate(['/createtournament/' + this.tournamentId + "/2"]);
        this.getlogo(this.tournamentId);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Sponsor failed', life: 6000 });
      })
    );
  }

  updatelogo(sponsorlogo) {
    this.tournamentservice.updatelogo(this.tournamentId, sponsorlogo).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Sponsor Logo Updated Successfully', life: 6000 });
        setTimeout(() => {
        }, 2000);
        //this.router.navigate(['/createtournament/' + this.tournamentId + "/2"]);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Sponsor Logo failed', life: 6000 });
      })
    );
  }


  openFactsheet() {
    this.router.navigate(['/tournaments/factsheet/' + this.tournamentId]);
  }
  oncatsubmit() {
    var categorydata = this.categoryform.value;
    this.catsubmitted = true;
    if (this.categoryform.invalid) {//} && this.step == 1) {
      return;
    }
    categorydata['matchCategoryArray'].forEach(element => {
      if (element.categoryId == null) {
        this.addTournamentCategory.push({ 'matchType': element['matchtype'].value, 'ageGroup': element['agegroup'].value, 'pointStructure': element['pointstructure'].value, 'maxPlayer': element['maxplayer'].value, 'entryFee': element.entryFee, 'disable': false, 'status': true })
      } else {
        this.updateTournamentCategory.push({ 'categoryId': element['categoryId'], 'matchType': element['matchtype'].value, 'ageGroup': element['agegroup'].value, 'pointStructure': element['pointstructure'].value, 'maxPlayer': element['maxplayer'].value, 'entryFee': element.entryFee, 'disable': false, 'status': true })
      }
    })
    //categorydata['matchCategoryArray'] = this.matchCategoryArray;
    categorydata['removedCategory'] = this.removedCategoryData;
    delete categorydata['matchCategoryArray'];
    categorydata['addTournamentCategory'] = this.addTournamentCategory;
    categorydata['updateTournamentCategory'] = this.updateTournamentCategory;
    categorydata['tournamentId'] = this.tournamentId;
    categorydata = JSON.stringify(categorydata, null, 4);
    this.addCategory(categorydata);
  }

  onsubmit() {

    this.submitted = true;

    if (this.tournamentform.invalid) {//} && this.step == 1) {
      return;
    }
    // if (this.signitureImage == undefined) {
    //   this.showPicError = true;
    //   return;
    // }
    if (this.tournamentId !="" && this.tournamentDirectorsign == undefined && this.uploadedSignitureFiles.length ==0) {
      this.showPicError = true;
      return;
    } else {
      this.showPicError = false;
    }
 
    this.step = this.step + 1;
    this.activeIndex = this.activeIndex + 1;

    if (this.step == 1) {    
      
      //console.log("formvalue", this.tournamentform.value);
      var tournamentData = this.tournamentform.value;
      tournamentData['phoneCode'] = tournamentData['phoneCode']['phone_code'];
      tournamentData['drawType'] = tournamentData['drawType']['id'];
      tournamentData['status'] = this.tournamentstatus;
      tournamentData['disable'] = false;
      tournamentData['countrycode'] = this.countryCode;
      tournamentData['countryname'] = this.countryName;
      tournamentData['statename'] = this.statename;
      tournamentData['statecode'] = this.statecode;
      tournamentData['statename'] = this.statename;
      tournamentData['statecode'] = this.statecode;
      tournamentData['citycode'] = this.citycode;
      tournamentData['cityname'] = this.cityname;
      tournamentData['courttype'] = this.selectedcourtType;
      tournamentData['academyId'] = this.loggedInAcademyId;
      tournamentData['authority_signiture'] = [{ file: this.signitureImage }];
      if (this.tournamentform.value.lastdateofregistration instanceof Date) {
        tournamentData['lastdateofregistration'] = moment(this.tournamentform.value.lastdateofregistration, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
      } else {
        var dt = moment(this.tournamentform.value.lastdateofregistration, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
        tournamentData['lastdateofregistration'] = dt;
      }
      
      // if (this.tournamentform.value.drawDate instanceof Date) {
      //   tournamentData['drawDate'] = moment(this.tournamentform.value.drawDate, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
      // } else {
      //   var dt = moment(this.tournamentform.value.drawDate, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
      //   tournamentData['drawDate'] = dt;
      // }

      if (this.tournamentform.value.startdate instanceof Date) {
        tournamentData['startdate'] = moment(this.tournamentform.value.startdate, "DD-MM-YYYY").format("YYYY-MM-DD");
      } else {
        var dt = moment(this.tournamentform.value.startdate, "DD-MM-YYYY").format("YYYY-MM-DD");
        tournamentData['startdate'] = dt;
      }
      if (this.tournamentform.value.enddate instanceof Date) {
        tournamentData['enddate'] = moment(this.tournamentform.value.enddate, "DD-MM-YYYY").format("YYYY-MM-DD");
      } else {
        var dt = moment(this.tournamentform.value.enddate, "DD-MM-YYYY").format("YYYY-MM-DD");
        tournamentData['enddate'] = dt;
      }
      if (this.tournamentform.value.lastdateofwithdraw instanceof Date) {
        tournamentData['lastdateofwithdraw'] = moment(this.tournamentform.value.lastdateofwithdraw, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
      } else {
        var dt = moment(this.tournamentform.value.lastdateofwithdraw, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
        tournamentData['lastdateofwithdraw'] = dt;
      }
      
      delete tournamentData['city'];
      delete tournamentData['state'];
      // delete tournamentData['courttype'];

      if (this.tournamentId == undefined) {
        tournamentData = JSON.stringify(tournamentData, null, 4);
        this.addTournament(tournamentData);
      }
      else if (this.tournamentId != undefined) {
        tournamentData = JSON.stringify(tournamentData, null, 4);
        this.updateTournament(tournamentData);
      }
    }
  }

  addTournament(tournamentData) {
    this.tournamentservice.addingTournament(tournamentData).subscribe(
      data => {
        this.tournamentId = data['id'];
        // this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Tournament Added Sucessfully', life: 6000 });
        setTimeout(() => {
        }, 2000);
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/createtournament/' + this.tournamentId + "/1"]);
        this.getlogo(this.tournamentId);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: err.error.message, life: 6000 });
      })
    );
  }

  addCategory(categorydata) {
    this.tournamentservice.addingTournamentCategory(categorydata).subscribe(
      data => {
        //return;
        // this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Category Added Sucessfully', life: 6000 });
        setTimeout(() => {

        }, 2000);
        //this.isTournamentCreate = true;
        this.step = 3;
        this.showpage = true;
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Category failed', life: 6000 });
      })
    );
  }
  updateTournament(tournamentData) {
    this.tournamentservice.updatetournament(this.tournamentId, tournamentData).subscribe(
      data => {
        // this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Tournament Updated Sucessfully', life: 6000 });
        setTimeout(() => {
        }, 2000);
        this.router.navigate(['/createtournament/' + this.tournamentId + "/1"]);
        //this.getTournamentId();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Tournament failed', life: 6000 });
      })
    )
  }
  updateCategory(categorydata) {
    this.tournamentservice.updatecategory(this.tournamentId, categorydata).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Category Updated Sucessfully', life: 6000 });
        setTimeout(() => {
        }, 2000);
        this.showpage = true;
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Category failed', life: 6000 });
      })
    )
  }

  next() {
    this.step = this.step + 1;
    this.activeIndex = this.activeIndex + 1;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/createtournament/' + this.tournamentId + "/" + this.step]);
  }

  previous() {
    //console.log("before: " + this.step + "   " + this.activeIndex);
    this.step = this.step - 1;
    this.activeIndex = this.activeIndex - 1;
    // console.log("After: " + this.step + "   " + this.activeIndex);
    // console.log('/createtournament/' + this.tournamentId + "/" + this.step);
    if (this.step == 0) {
      this.tournamentform.get('enddate').setErrors(null);

    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/createtournament/' + this.tournamentId + "/" + this.step]);
  }
  onActiveIndexChange(event) {
    if (event == 0) {
      this.step = 0;
      this.activeIndex = 0;
      if (this.isTournamentCreate == false) {
        this.tournamentform.get('enddate').setErrors(null);
      }
    }
    else if (event == 1) {
      this.step = 1;
      this.activeIndex = 1;
    } else if (event == 2) {
      this.activeIndex = 2;
      this.step = 2;
    }
  }
  onClickDelete() {
    var query = "?filterBySponserLogoId=" + this.imageid
    this.tournamentservice.deletelogo(query).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Delete Sucessfully', life: 6000 });
        setTimeout(() => {
        }, 2000);
        this.showpage = true;
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Delete failed', life: 6000 });
      })
    )
  }
  openmodal() {
    this.showinglogoForm = true;

  }
  onCloseModal() {
    this.showinglogoForm = false;
  }

  deletsponsor(id) {
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Are you sure you want to delete sponsor logo?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });        
        let updatedata = '{"disable":true}';
        this.tournamentservice.updatelogo(id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Sponsor logo Deleted', life: 3000 });
            let currentUrl = this.router.url;
            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //   this.router.navigate([currentUrl]);
            // });
            this.getlogo(this.tournamentId);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      }
    });

  }
  onCloseSponsorDialog() {
    this.showImageError = false;
  }


  signitureUploader(event) {
    for (let file of event.files) {
      this.uploadedSignitureFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.signitureImage = reader.result;
        }
      }
    }
  }
  removeFile(event) {
    this.uploadedSignitureFiles = [];
    this.signitureImage ="";
    //this.profilepic = "{{imageProfile}}";
  }
  backButton() {
    this.router.navigate(['/academies-profile/our-tournaments']);
  }
}
